export default __webpack_public_path__ + "static/media/KS.5db98067.png";